import { render, staticRenderFns } from "./RequestHistory.vue?vue&type=template&id=164b6c99&scoped=true"
import script from "./RequestHistory.vue?vue&type=script&lang=js"
export * from "./RequestHistory.vue?vue&type=script&lang=js"
import style0 from "./RequestHistory.vue?vue&type=style&index=0&id=164b6c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b6c99",
  null
  
)

export default component.exports